import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import procedures from '../data/procedures';

const ProcedureCard = ({ procedure, isDesktop }) => {
  return (
    <Link to={`/procedures/${procedure.slug}`} className="block">
      <div
        className={`border border-teal-300 rounded-xl p-5 mb-4 shadow-sm transition-all duration-300
          ${isDesktop ? 'hover:shadow-xl hover:border-teal-500 hover:scale-[1.03]' : 'bg-teal-50'}`}
      >
        <h4 className="text-lg font-semibold text-teal-700">{procedure.title}</h4>
        {isDesktop && <p className="text-sm text-teal-600 mt-2">{procedure.short}</p>}
      </div>
    </Link>
  );
};

const Procedures = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categorizedProcedures = useMemo(() => {
    return procedures.reduce((acc, procedure) => {
      if (!acc[procedure.category]) acc[procedure.category] = [];
      acc[procedure.category].push(procedure);
      return acc;
    }, {});
  }, []);

  const categories = useMemo(() => Object.keys(categorizedProcedures), [categorizedProcedures]);

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  return (
    <section className="py-12 px-4 max-w-6xl mx-auto">
      <h2 
        className="text-3xl font-bold text-center text-teal-900 mb-3" 
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Procedures Offered
      </h2>
      <div className="w-20 h-1 bg-teal-600 mx-auto mb-5" />

      <div className="flex justify-center mb-8 flex-wrap gap-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
        <button
          onClick={() => handleCategoryChange('all')}
          className={`px-5 py-2 rounded-full text-sm font-medium transition ${activeCategory === 'all' ? 'bg-teal-600 text-white' : 'bg-teal-100 text-teal-700'}`}
        >
          All
        </button>
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => handleCategoryChange(category)}
            className={`px-5 py-2 rounded-full text-base font-medium transition ${activeCategory === category ? 'bg-teal-600 text-white' : 'bg-teal-100 text-teal-700'}`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Desktop View - 3-column grid */}
      <div className="hidden md:grid grid-cols-3 gap-6">
        {(activeCategory === 'all' ? categories : [activeCategory]).map(category => (
          <div key={category}>
            <h3 className="text-3xl font-semibold text-teal-700 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {category}
            </h3>
            {categorizedProcedures[category].map((procedure) => (
              <ProcedureCard
                key={procedure.slug}
                procedure={procedure}
                isDesktop={true}
              />
            ))}
          </div>
        ))}
      </div>

      {/* Mobile View - Single column */}
      <div className="md:hidden">
        {(activeCategory === 'all' ? procedures : categorizedProcedures[activeCategory]).map((procedure) => (
          <ProcedureCard
            key={procedure.slug}
            procedure={procedure}
            isDesktop={false}
          />
        ))}
      </div>
    </section>
  );
};

export default Procedures;